import axios from 'axios';
import ENV from '../../../environment';
import { determineFactorForMaterial, getVariantNumberPrefixFromHeaderRow } from '../../helpers';

export default {
  state: {
    options: [],
    selection: {},
    secondarySelection: {},
  },

  mutations: {
    setOptions(state, options) {
      state.options = options;
    },

    setSelectedOption(state, option) {
      state.selection = option;
    },

    setSelectedSecondaryOption(state, option) {
      state.secondarySelection = option;
    },
  },

  actions: {
    async fetchOptions({ commit }) {
      let materials = await axios.get(ENV.baseUrl + ENV.sheetsEndpoint + "?range=untergrund!A1:G9" + "&pluginSetPreview=" + ENV.setPreview)
      if (!materials.data) return;

      let headers = materials.data.shift(); // Get the first row, which contains the header names

      materials = materials.data.map((row, index) => {
        // Map headers to row
        let rowAsObject = {};
        headers.forEach((header, index) => {
          rowAsObject[header] = row[index];
        });

        row = rowAsObject;

        let material = {
          name: row["Optionen"],
          position: index,
          options: []
        };

        // Empfehlung
        material.options.push({
          name: row["Empfehlung"],
          type: "Empfehlung",
          position: 1,
          factor: determineFactorForMaterial("Empfehlung", row),
          variantNumberPrefix: getVariantNumberPrefixFromHeaderRow("Empfehlung", row)
        })

        // Alternative 1
        material.options.push({
          name: row["Alternative 1"],
          type: "Alternative 1",
          position: 2,
          factor: determineFactorForMaterial("Alternative 1", row),
          variantNumberPrefix: getVariantNumberPrefixFromHeaderRow("Alternative 1", row)
        })
        
        // Alternative 2
        material.options.push({
          name: row["Alternative 2"],
          type: "Alternative 2",
          position: 3,
          factor: determineFactorForMaterial("Alternative 2", row),
          variantNumberPrefix: getVariantNumberPrefixFromHeaderRow("Alternative 2", row)
        })
        
        return material;
      })


      commit('setOptions', materials);
    },

    selectOption ({ commit }, option) {
      commit('setSelectedOption', option);
    },

    selectSecondaryOption ({ commit }, option) {
      commit('setSelectedSecondaryOption', option);
    },
  },

};
